import { render, staticRenderFns } from "./jbzl_details.vue?vue&type=template&id=a67b8f00&scoped=true&"
import script from "./jbzl_details.vue?vue&type=script&lang=js&"
export * from "./jbzl_details.vue?vue&type=script&lang=js&"
import style0 from "./jbzl_details.vue?vue&type=style&index=0&id=a67b8f00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b8f00",
  null
  
)

export default component.exports